import { format, formatDistanceToNow, getTime } from 'date-fns';

export type DateInput = Date | string | number | undefined;

export function fDate(date: DateInput, newFormat?: string): string {
    const fm = newFormat || 'dd MMM yyyy';

    return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date: DateInput, newFormat?: string): string {
    const fm = newFormat || 'dd MMM yyyy p';

    return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date: DateInput): number | undefined {
    return date ? getTime(new Date(date)) : undefined;
}

export function fToNow(date: DateInput): string {
    return date
        ? formatDistanceToNow(new Date(date), {
            addSuffix: true,
        })
        : '';
}
